interface LayoutEvent {
    startAt: Date;
    duration: number;
}

export interface EventLayout {
    column: number;
    totalColumns: number;
}

const getOverlappingEventsLayout = (events: LayoutEvent[]): EventLayout[] => {
    const layouts: EventLayout[] = events.map(() => ({ column: 0, totalColumns: 1 }));

    const sortedIndexes = events
        .map((_, index) => index)
        .sort((a, b) => {
            const startDiff = events[a].startAt.getTime() - events[b].startAt.getTime();
            if (startDiff !== 0) return startDiff;
            return events[b].duration - events[a].duration;
        });

    let cluster: number[] = [];
    let columnsEnd: number[] = [];
    let clusterEnd = -Infinity;

    const closeCluster = () => {
        cluster.forEach((index) => {
            layouts[index].totalColumns = columnsEnd.length;
        });
        cluster = [];
        columnsEnd = [];
        clusterEnd = -Infinity;
    };

    sortedIndexes.forEach((index) => {
        const start = events[index].startAt.getTime();
        const end = start + events[index].duration * 1000;

        if (start >= clusterEnd) {
            closeCluster();
        }

        let column = columnsEnd.findIndex((columnEnd) => columnEnd <= start);
        if (column === -1) {
            column = columnsEnd.length;
            columnsEnd.push(end);
        } else {
            columnsEnd[column] = end;
        }

        layouts[index].column = column;
        cluster.push(index);
        clusterEnd = Math.max(clusterEnd, end);
    });

    closeCluster();

    return layouts;
};

export default getOverlappingEventsLayout;
